import React, { FunctionComponent, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { Student } from "../../../../../../store/onboarding/types";
import AddStudentOverlay from "./AddStudentOverlay";
import { GroupRecommendation } from "../../../../../../store/onboarding/cases/types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type OwnProps = {
  selectedStudents: Student[];
  onAdd: (students: Student[]) => void;
  groupRecommendation?: GroupRecommendation,
  fromRecommendation?: boolean;
};

type Props = OwnProps;

const AddStudentsPopover: FunctionComponent<Props> = (props) => {
  const { selectedStudents, onAdd, groupRecommendation, fromRecommendation } = props;
  const target = useRef<any>();
  const [show, setShow] = useState<boolean>(false);

  const handleAdd = (student: Student[]) => {
    onAdd(student);
    setShow(false);
  };

  return (
    <>
      <AddStudentOverlay
        target={target}
        show={show}
        setShow={setShow}
        selectedStudents={selectedStudents}
        onAdd={handleAdd}
        title={`Select existing student(s) to include them in the group.`}
        btnText={"ADD STUDENT(S)"}
        placement={"top"}
        group={groupRecommendation}
        fromRecommendation={fromRecommendation}
      />
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="top"
        overlay={
          <Tooltip className="customTooltip" id="tooltip-top">
            Add existing student(s).
          </Tooltip>
        }
      >
        <span className="pointer" ref={target} onClick={() => setShow(true)}>
          <FontAwesomeIcon icon={faPlusCircle} size="lg" />
        </span>
      </OverlayTrigger>
    </>
  );
};

export default AddStudentsPopover;
